import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ServiceAreasAlerts} from "../../../service-areas/services/service-areas-alerts.service";
import {ServiceAreaRequests} from "../../../service-areas/services/service-area-requests.service";
import {BranchModel} from "../../models/branch.model";

export class branchServiceAreasCtrl implements IController {

  branch: BranchModel;
  serviceAreas: any;

  private serviceAreasRef: any;
  public serviceAreaIds: any;

  /* @ngInject */
  constructor(private $log, private serviceAreasAlerts: ServiceAreasAlerts, private bringozLoaderService: BringozLoaderService,
              private serviceAreaRequests: ServiceAreaRequests, private $serviceArea) {
    this.serviceAreasRef = this.$serviceArea();
  }

  $onInit() {
    this.serviceAreaIds = _.map(this.serviceAreas, (area) => {
      return area.areaId;
    })
  }

  // ******************************
  //         Public methods
  // ******************************

  onServiceAreaChange(updatedAreas) {
    let updatedAreaIds = _.map(updatedAreas, (updatedArea) => {
      return updatedArea.areaId;
    });

    let serviceAreasToRemoveBranchId = _.filter(this.serviceAreas, (area) => {
      return _.indexOf(updatedAreaIds, area.areaId) === -1;
    });

    // Adding / Removing Branch Id From Service Areas
    let serviceAreasAfterRemove = this._removeBranchFromServiceAreas(serviceAreasToRemoveBranchId);
    let serviceAreasAfterAdd = this._addBranchToServiceAreas(updatedAreas);

    // Service Areas That Needs Server Update
    let payload = serviceAreasAfterRemove.concat(serviceAreasAfterAdd);

    this.bringozLoaderService.on();
    this.serviceAreaRequests.updateAreasBranches(payload)
      .then((updatedServiceAreas) => {
        this.serviceAreas = updatedAreas;
        this.serviceAreaIds = _.map(updatedAreas, (area) => {
          return area.areaId;
        })
        this.serviceAreasAlerts.updateManySuccess();
      })
      .catch((error) => {
        this.serviceAreasAlerts.updateManyError();
        this.$log.error('Failed to updated Service Areas @branchServiceAreas@onServiceAreaChange', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  // ******************************
  //         Private methods
  // ******************************

  private _removeBranchFromServiceAreas(serviceAreas) {
    _.forEach(serviceAreas,(area) => {
      area.branchIds = _.without(area.branchIds, this.branch.id);
    });
    return serviceAreas;
  }

  private _addBranchToServiceAreas(serviceAreas) {
    let serviceAreasToAdd = [];
    _.forEach(serviceAreas,(area) => {

      if (!area.branchIds) {
        area.branchIds = [];
      }

      let branchIdIndex = _.indexOf(area.branchIds, this.branch.id);

      if (branchIdIndex === -1) {
        area.branchIds.push(this.branch.id);
        serviceAreasToAdd.push(area)
      }
    });
    return serviceAreasToAdd;
  }

}
angular
  .module('bringoz.admin.branches')
  .component('branchServiceAreas', {
    bindings: {
      branch: '<',
      serviceAreas: '<'
    },
    template: require('./branch-service-areas.html').default,
    controller: branchServiceAreasCtrl
  });
